<template>
    <div>
      <AcompanhamentoForm :acompanhamento="null" />
    </div>
  </template>
  
  <script>
  import AcompanhamentoForm from "../../components/acompanhamento/AcompanhamentoForm.vue";
  
  export default {
    name: "AcompanhamentoNew",
    data() {
      return {};
    },
    components: {
      AcompanhamentoForm,
    },
  };
  </script>
  
<style lang="scss" scoped></style>
  